import { Component } from "react";
import { Container } from 'reactstrap';

export class TermsCondiciones extends Component {
    render() {
        return (
            <Container>
                Para acceder a esta pagina usted debe leer y aceptar <br />
                los <img src="/pdf-icon.png" width="20px" alt="PDF" /> <a href="/api/Documento" target="_blank"> Terminos y condiciones. </a>
            </Container>
        );
    }
}